import Vue from "vue";
import Vuex from "vuex";
import VueAxios from "vue-axios";
import axios from "axios";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

const namespaced = true;

const state = {
  ajaxPendingConnectionsCount: 0
};

const getters = {
  loading: state => state.ajaxPendingConnectionsCount > 0
};

const mutations = {
  UPDATE_PENDING_CONNECTIONS: (state, pendingConnections) => {
    state.ajaxPendingConnectionsCount = pendingConnections;
  }
};

const actions = {
  RAISE_PENDING_CALLS: ({ commit /*, dispatch*/, state }) => {
    commit("UPDATE_PENDING_CONNECTIONS", state.ajaxPendingConnectionsCount + 1);
  },
  LOWER_PENDING_CALLS: ({ commit /*, dispatch*/, state }) => {
    commit("UPDATE_PENDING_CONNECTIONS", state.ajaxPendingConnectionsCount - 1);
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
